/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import PropTypes from "prop-types";

import store from "@untyped-store";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
import ScopedCssBaseline from "@mui/material/ScopedCssBaseline";
import theme from "@untyped-styles/theme";
import I18nProvider from "./i18nProvider";

function RootComponent({ children, providedStore, i18nOverrides }) {
  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <Provider store={providedStore || store}>
          <I18nProvider i18nOverrides={i18nOverrides || {}}>
            {children}
          </I18nProvider>
        </Provider>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}

RootComponent.propTypes = {
  children: PropTypes.node,
  providedStore: PropTypes.object,
  i18nOverrides: PropTypes.object,
};

export default RootComponent;
